/* eslint-disable complexity */

import { TripTypeOptions } from '@com-delta-idp/mnx-capability-flight-shop-ui';
import {
  DefaultLookupFieldsConfig,
  DefaultLookupFieldsValue,
  DefaultLookupResponse
} from '../../models/core-apis/default-lookup.interfaces';
import { stringToBoolean } from '../utils/utils.adapter';

export const prepareDefaultLookupFieldsValue = (
  defaultLookupLandingData: DefaultLookupResponse | null
): DefaultLookupFieldsValue | null => {
  if (
    defaultLookupLandingData?.searchCriteria &&
    defaultLookupLandingData?.accountableDocumentsForPassenger?.length &&
    defaultLookupLandingData?.accountableDocumentsForPassenger.some(
      (document) => document?.accountableDocuments?.length
    )
  ) {
    const {
      edocDefaultPaxCount: selectedPaxValue,
      edocMaxPaxCount: maxPaxCount,
      edocMinPaxCount: minPaxCount,
      journeyTypeOptions,
      fareBrandsByMoney
    } = defaultLookupLandingData.searchCriteria;

    const tripTypeOptions: TripTypeOptions[] = [];
    let selectTripType = journeyTypeOptions[0].value;

    journeyTypeOptions.forEach(({ isDefaulted, value }) => {
      tripTypeOptions.push(value);

      if (stringToBoolean(isDefaulted)) {
        selectTripType = value;
      }
    });

    return {
      tripTypeOptions,
      selectTripType,
      selectedPaxValue,
      minPaxCount,
      maxPaxCount,
      bestFareOptions: fareBrandsByMoney?.length ? fareBrandsByMoney : []
    };
  }

  return null;
};

export const prepareDefaultLookupFieldsConfig = (
  defaultLookupLandingData: DefaultLookupResponse | null
): DefaultLookupFieldsConfig | null => {
  if (
    defaultLookupLandingData?.searchCriteria &&
    defaultLookupLandingData?.accountableDocumentsForPassenger?.length &&
    defaultLookupLandingData?.accountableDocumentsForPassenger.some(
      (document) => document?.accountableDocuments?.length
    )
  ) {
    const {
      disableTripType,
      disablePaxDropDown,
      disableShowPriceIn: disableShopMiles,
      disableBestFaresFor: disableBestFares,
      disableMeetingCode,
      disableRefundableFares,
      disableNearbyAirport,
      disableEdocLink,
      disableFlexibleDates,
      hideBasicFares
    } = defaultLookupLandingData.searchCriteria;

    return {
      disableTripType,
      disablePaxDropDown,
      disableShopMiles,
      disableBestFares,
      disableMeetingCode,
      disableRefundableFares,
      disableNearbyAirport,
      disableEdocLink,
      disableFlexibleDates: stringToBoolean(disableFlexibleDates),
      hideBasicFares
    };
  }

  return null;
};
